import classNames from 'classnames';
import QuantitySelect from '../QuantitySelect';
import { useAddToCartAction } from './AddToCart.hooks';

export interface AddToCartButtonProps {
  showQuantitySelector: boolean;
}

const AddToCartButton = ({
  showQuantitySelector,
}: AddToCartButtonProps) => {
  const { disabled, triggerAddToCart } = useAddToCartAction();

  return (
    <div className="pdp-add">
      {showQuantitySelector && <QuantitySelect label="quantitySelector"/>}
      <div
        className={classNames('pdp-add-button btn btn-yellow', { disabled })}
        role="button"
        onClick={triggerAddToCart}
      >
        <span>Add To Cart</span>
      </div>
    </div>
  );
};

export default AddToCartButton;
